import {Component, HostListener, OnInit} from "@angular/core";
import {Merchant, UserControllerService, UserShiftRes} from '../../../@services/gen';
import {AuthService} from '../../../@services/auth.service';
import {kickCashDrawerz, printz} from "../../../@services/utils";
import {Location} from '@angular/common';
import {LocalstorageService} from '../../../@services/localstorage.service';
import {Router} from '@angular/router';
import {PosItemService} from '../../../@services/pos-item.service';
import {NotificationService} from '../../../@services/notification.service';
import {PaymentService} from '../../../@services/payment.service';
import {TdDialogService} from '@covalent/core/dialogs';
import {KitchenService} from '../../../@services/kitchen.service';
import {UserShiftService} from "../../../@services/user-shift.service";

@Component({
  selector: 'app-shift-closing',
  templateUrl: './shift-closing.component.html',
  styleUrls: ['./shift-closing.component.scss'],
})
export class ShiftClosingComponent implements OnInit {
  title = 'Shift Closing Form';
  merchant: Merchant;
  closingCash: number;
  loading = {
    shiftSummary: false,
  };
  shiftSummary: UserShiftRes;
  isMobile: boolean = false;

  constructor(
    private userService: UserControllerService,
    private customPosItemService: PosItemService,
    private customPaymentService: PaymentService,
    private customKitchenService: KitchenService,
    private customAuthService: AuthService,
    public location: Location,
    private router: Router,
    private ls: LocalstorageService,
    private ns: NotificationService,
    private ds: TdDialogService,
    private userShiftService: UserShiftService

  ) {
    this.checkIsMobile();
  }

  ngOnInit(): void {
    this.merchant = this.ls.getMerchant();
    this.load();
    kickCashDrawerz();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkIsMobile();
  }

  private checkIsMobile() {
    this.isMobile = window.innerWidth < 768; // You can adjust the threshold as needed
  }

  private load() {
    this.loadShiftSummary();
  }

  private loadShiftSummary() {
    this.loading.shiftSummary = true;
    this.userService
      .getUserShiftSummaryPost({
        merchantId: this.ls.getMerchant().id,
        cashierId: this.customAuthService.getUser().userId
      })
      .subscribe(
        (value) => {
          this.loading.shiftSummary = false;
          this.shiftSummary = value;
        },
        (error) => {
          this.loading.shiftSummary = false;
        }
      );
  }

  submit() {
    let dialogRef = this.ns.showNotification({
      message: 'Please wait...',
      icon: 'fa fa-sync',
      manualClose: true,
    });

    this.userService
      .startStopUserShiftPost({
        actionType: 'finish',
        userShift: {
          closingCash: this.closingCash,
          merchant: {id: this.merchant.id},
          dposUser: {id: this.customAuthService.getUser().userId}
        },
      })
      .subscribe(
        async (userShift) => {
          this.printClosingReport(userShift, () => {});
          dialogRef.close();
          this.customPosItemService.cachePosItemVsMerchant$ = null;
          this.customKitchenService.stopTimerIncomingKitchenOrder();
          this.userShiftService.clearUserShift();

          this.router.navigate(["/login"]).then(() => {
          });
        },
        (error) => {
          dialogRef.close();
          this.ds.openAlert({
            message: error?.error?.message,
          });
        }
      );
  }

  private printClosingReport(userShift: UserShiftRes, cb: Function) {
    let posId = this.ls.getPosId();
    for (let mvp of this.merchant.merchantVsPrinters.filter(x => x.posId === posId || !x.posId)) {

      if (mvp.printClosingReceipt) {
        this.customPaymentService.getClosingReceipt(
          userShift.id,
          mvp.printer.paperSizeType == 'BIG' ? 45 : 32,
          (res) => {
            printz(
              {
                printerName: mvp.printer.printerName,
                printerType: mvp.printer.printerType,
                vendorId: mvp.printer.printerVendorId,
                ipAddress: mvp.ipAddress,
                macAddress: mvp.macAddress,
              },
              [res]
            );
          }
        );
      }
    }
    cb();
  }

  onEnter(event: Event) {
    event.preventDefault(); // Prevent the default form submission
    this.submit(); // Call the submit method
  }
}
